import { AbsoluteFill, useVideoConfig } from 'remotion'
import ZealousSvg from '../assets/ZealousSvg'

/**
 * The Zealous mark over a render (#546): a render-level overlay, never an
 * item. `doc.watermark` says whether to draw it — decided at hydration from
 * the org's plan (`hydrateTimeline`), on for the free plan — so the editor's
 * canvas (`starter/canvas/composition.tsx`, through `WatermarkContext`) and
 * Lambda (`TimelineComposition`) draw the same thing and a free user has
 * nothing to select, move or delete. Template tiles never draw it.
 *
 * One fixed corner, bottom-right, white at half opacity under a soft shadow
 * so it reads on any theme; the v1 layouts placed it per layout in the
 * `logo` colour role, which no longer applies.
 */

/** The mark's height and inset: v1's 49 px tall, 60 px in, on a 1080 px side. */
export function watermarkBox(
  width: number,
  height: number,
): { height: number; right: number; bottom: number } {
  const side = Math.min(width, height)
  const inset = Math.round(side * 0.055)
  return { height: Math.round(side * 0.045), right: inset, bottom: inset }
}

export function Watermark() {
  const { width, height } = useVideoConfig()
  const box = watermarkBox(width, height)
  return (
    <AbsoluteFill style={{ pointerEvents: 'none' }} data-watermark="">
      <ZealousSvg
        color="#ffffff"
        style={{
          position: 'absolute',
          right: box.right,
          bottom: box.bottom,
          height: box.height,
          opacity: 0.5,
          filter: 'drop-shadow(0 1px 4px rgba(0, 0, 0, 0.45))',
        }}
      />
    </AbsoluteFill>
  )
}
